import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import moment from "moment";
import ApiMethods from "../../../../ApiManager/ApiMethods";
import "react-datepicker/dist/react-datepicker.css";
import CardClientTest from "./CardClientTest";
import CircularButton from "./CircularButton";
import CardEdit from "./CardTestEdit";
import { SchedulePopoverTest } from "./SchedulerPopOverTest";
import SideBarTest from "./SideBarTest";
import changeAgendaData from "./SideBarTest";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import PopupTest from "./PopUpTest";
import PopupCard from "./PopUpCard";
import NewAppointmentFlow from "./NewAppointmentFlow";
import BulkSelectionPanel from "./BulkSelectionPanel";
import CalendarWeekNav from "./CalendarWeekNav";
import MobileWeekGrid from "./MobileWeekGrid";
import {
  getSlotCapacityRules,
  canOfficeAddMember,
} from "../../../../common/utils/capacity";
import WorkHistoryIcon from "@mui/icons-material/WorkHistory";

import Contacts from "./Contacts";
import EditRoundedIcon from "@mui/icons-material/EditRounded";

import Avatar from "@mui/material/Avatar";
import { Email, Phone, Edit } from "@mui/icons-material";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LocalPhoneOutlinedIcon from "@mui/icons-material/LocalPhoneOutlined";
import DeletePopUp from "./DeletePopUp";
import { IconButton } from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import CardClient from "./CardClient";
import Agenda from "./Agenda";
import { useAlert } from "../../../context/AlertContext";
import CardGiftcardOutlinedIcon from "@mui/icons-material/CardGiftcardOutlined";
import AddIcon from "@mui/icons-material/Add";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ClientPackageDialog from "./ClientPackageDialog";
import ClientPackagesList from "./ClientPackagesList";
import {
  invalidateMembersCache,
  refreshClientPackages,
} from "../../../data/membersStore";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { useNotifications } from "../../../context/NotificationsContext";
import "./scheduler.css";

export const appointmentStatuses = {
  FULL: "full",
  AVAILABLE: "available",
  BOOKED: "booked",
};

export const appointmentStatusesProps = {
  FULL: {
    backgroundColor: "#fff",
    title: "Popunjeno",
  },
  AVAILABLE: {
    backgroundColor: "#98C3F2",
    title: "",
  },
  BOOKED: {
    backgroundColor: "#357a38",
    title: "Rezervisano",
  },
};
const SchedulerTest = ({
  startHour = 8,
  endHour = 21,
  handleNavigate,
  selectedDate,
}) => {
  const { unreadCount, openNotif } = useNotifications();
  const [appointments, setAppointments] = useState({});
  const [isMyAppointment, setMyAppointment] = useState([]);
  const [isSideBarOpen, setIsSideBarOpen] = useState(null);
  const [clientScheduler, setClientScheduler] = useState(0);
  const [activeClientId, setClientActiveId] = useState(null);
  const [activeReschedule, setActiveReschedule] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [activeClientInformation, setActiveClientInformation] = useState(null);
  const [openUsersPopUp, setUsersPopuop] = useState(null);
  // Set right before an edit-appointment save that actually moves the
  // member to a different slot, so the very next bookings fetch (which
  // that save's `refresh` call already triggers) closes the now-stale
  // Booked Members popup unconditionally instead of just resyncing it —
  // see handleFetchBookings and the NewAppointmentFlow `refresh` prop below.
  const forceCloseUsersPopUpRef = useRef(false);
  const [openSidebarClient, setOpenSidebarClient] = useState(false);
  const [openDeletePopUp, setOpenDeletePopUp] = useState(false);
  const [updateActiveReschedule, setUpdateActiveReschedule] = useState(false);
  const [syncContacts, setSyncContacts] = useState(false);
  const [activeAppointment, setActiveAppointment] = useState({});
  const [activeClientInfo, setActiveClientInfo] = useState({});
  const [bookingAdded, setBookingAdded] = useState(false);
  const [openAgenda, setOpenAgenda] = useState(false);
  const [deleteAppointment, setDeleteAppointment] = useState(false);
  const { showAlert, closeAlert } = useAlert();
  const [onConfirm, setOnConfirm] = useState(() => {});
  const [clientPackages, setClientPackages] = useState([]);
  const [packageDialogOpen, setPackageDialogOpen] = useState(false);
  const [editingClientPackage, setEditingClientPackage] = useState(null);
  const [openNewAppointment, setOpenNewAppointment] = useState(false);
  // Holds { client, appointment } when "Izmeni termin" is clicked from the
  // Zakazani članovi popup — opens the same NewAppointmentFlow modal, in
  // edit mode, instead of the old full-calendar reschedule UI.
  const [editingAppointmentContext, setEditingAppointmentContext] =
    useState(null);

  // Mobile Home redesign: a single-day agenda list replaces the 6-column
  // week grid below 768px. Tablet/Desktop render the original grid
  // unchanged (separate JSX branch further down), so none of this affects
  // them.
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < 768 : false
  );
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const location = useLocation();

  // Members screen can deep-link here with a client pre-selected
  // (navigate("/", { state: { presetClient } })) so staff can jump straight
  // from a member's card into scheduling for them.
  useEffect(() => {
    if (location.state?.presetClient) {
      setActiveClientInformation(location.state.presetClient);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state]);

  const currentDay = selectedDate.getDay();

  const diffToMonday = currentDay === 0 ? -6 : 1 - currentDay;
  const currentWeekDates = [];
  for (let i = 0; i < 7; i++) {
    const day = new Date(selectedDate);
    day.setDate(selectedDate.getDate() + diffToMonday + i);
    if (i !== 6) {
      currentWeekDates.push(day);
    }
  }
  const weekRangeLabel = `${moment(currentWeekDates[0]).format("D MMM")} – ${moment(
    currentWeekDates[currentWeekDates.length - 1]
  ).format("D MMM YYYY")}`;

  // Which of the 6 displayed weekdays (Mon-Sat) the Mobile agenda is
  // currently showing. Defaults to today's weekday when today falls inside
  // the week currently on screen, otherwise Monday.
  const getWeekdayIndex = (date) => {
    const day = date.getDay();
    return day === 0 ? 5 : day - 1;
  };
  const [mobileActiveDayIndex, setMobileActiveDayIndex] = useState(() => {
    const idx = getWeekdayIndex(new Date());
    return currentWeekDates[idx] &&
      moment(currentWeekDates[idx]).isSame(moment(), "day")
      ? idx
      : 0;
  });
  const handleMobileToday = () => {
    handleNavigate("today");
    setMobileActiveDayIndex(getWeekdayIndex(new Date()));
  };

  // Mobile-only: Day (single-day agenda, existing) vs Week (new horizontally-scrollable
  // grid) — purely a local display toggle, doesn't affect what's fetched (appointments are
  // already loaded for the whole displayed week regardless of which view is showing, see the
  // handleFetchBookings effect below), so switching back and forth never refetches.
  const [viewMode, setViewMode] = useState("week");
  // Set when an empty cell is tapped in Week View, so NewAppointmentFlow opens with that exact
  // date+hour preselected instead of the FAB's usual blank slate. Cleared on close.
  const [weekTapSlot, setWeekTapSlot] = useState(null);
  const handleWeekEmptySlotTap = (date, hour) => {
    // Bulk-scheduling experiment (this branch only) replaced the old
    // "tap an empty cell to prefill Novi termin" shortcut — every creation
    // entry point now goes through the same Select Member → Select
    // Appointment flow below, so the tapped date/hour is no longer used.
    startBulkFlow();
  };

  // ================= Bulk-scheduling experiment (this branch only) =================
  // New flow: New Appointment → pick a member (no date/time in that popup
  // anymore) → the popup closes and the Calendar itself becomes the picker,
  // showing only reservation counts and accepting up to MAX_BULK_SLOTS taps
  // → a right-side (Desktop/Tablet) or bottom (Mobile) panel lists what's
  // selected → Save creates all of them in one request.
  const MAX_BULK_SLOTS = 3;
  const [bulkStep, setBulkStep] = useState(null); // null | "member" | "select"
  const [bulkMember, setBulkMember] = useState(null);
  const [bulkSlots, setBulkSlots] = useState([]); // [{ id, start, end }]
  const [bulkSaving, setBulkSaving] = useState(false);
  // Shown on a selected cell instead of the checkmark — same initials
  // convention as MemberResultRow/the profile avatar elsewhere in the app.
  const bulkMemberInitials = bulkMember
    ? `${bulkMember.first_name ? bulkMember.first_name[0].toUpperCase() : "?"}${
        bulkMember.last_name ? bulkMember.last_name[0].toUpperCase() : ""
      }`
    : "";
  // Snapshot of the member's own bookings for the currently displayed week, taken the moment
  // they're chosen and left untouched afterward — the one source of truth `handleBulkSave`
  // diffs the final `bulkSlots` selection against to decide what to actually create/cancel.
  // `appointments` already holds every slot's full booking list for this week (see
  // handleFetchBookings above), so no extra fetch is needed to build this.
  const [bulkOriginalBookings, setBulkOriginalBookings] = useState([]); // [{ id, start, end, booking_id }]

  const startBulkFlow = () => {
    // Bulk-cell selection (renderTimeSlot's onEmptySlotClick path further below) is only wired
    // up for the Week View grid on Mobile — starting the flow from Day View left the calendar
    // with no way to actually tap a slot. Force Week View here so every entry point (the FAB,
    // and handleWeekEmptySlotTap below) always lands somewhere selection actually works.
    if (isMobile) setViewMode("week");
    setBulkStep("member");
  };
  const closeBulkFlow = () => {
    setBulkStep(null);
    setBulkMember(null);
    setBulkSlots([]);
    setBulkOriginalBookings([]);
  };
  const handleBulkMemberChosen = (member) => {
    if (!member) return;
    const memberId = member.id ?? member.client_id;
    const existing = [];
    Object.values(appointments).forEach((appt) => {
      const booking = (appt.bookings_client || []).find(
        (b) => b.client_id === memberId
      );
      if (booking) {
        existing.push({
          id: appt.id,
          start: appt.start,
          end: appt.end,
          booking_id: booking.booking_id,
        });
      }
    });
    setBulkMember(member);
    // The member's existing appointments this week start out selected, exactly like a slot the
    // trainer just tapped — same visuals (isBulkSelected in renderTimeSlot below doesn't
    // distinguish the two), same toggle behavior. `bulkOriginalBookings` is the immutable
    // snapshot Save diffs the eventual `bulkSlots` state against.
    setBulkSlots(existing.map(({ id, start, end }) => ({ id, start, end })));
    setBulkOriginalBookings(existing);
    setBulkStep("select");
  };
  const toggleBulkSlot = (appointment) => {
    if (!appointment) return;
    // `showAlert` (an AlertProvider state update) must not run inside the setBulkSlots updater
    // below — React logs "Cannot update a component while rendering a different component"
    // when a state setter is called from inside another setter's updater function, since that
    // updater can run during render. Reading `bulkSlots` from this closure instead (safe here,
    // since toggleBulkSlot only ever runs from a click handler, never during render) keeps the
    // alert a plain side effect of the click itself.
    const exists = bulkSlots.some((s) => s.id === appointment.id);
    if (exists) {
      setBulkSlots((prev) => prev.filter((s) => s.id !== appointment.id));
      return;
    }
    if (bulkSlots.length >= MAX_BULK_SLOTS) {
      showAlert(`Najviše ${MAX_BULK_SLOTS} termina odjednom`, "error");
      return;
    }
    setBulkSlots((prev) => [
      ...prev,
      { id: appointment.id, start: appointment.start, end: appointment.end },
    ]);
  };
  const removeBulkSlot = (id) => {
    setBulkSlots((prev) => {
      const slot = prev.find((s) => s.id === id);
      // Mirrors the calendar cell's own past-lock (CardClientTest.jsx's `isLocked`) — the
      // panel already hides this button for a past card, this is just defense in depth.
      if (slot && moment(slot.start).isBefore(moment())) return prev;
      return prev.filter((s) => s.id !== id);
    });
  };
  const handleBulkSave = async () => {
    // Not just `bulkSlots.length === 0` — that's also the state after deselecting every one of
    // a member's originally-booked slots to cancel them (BulkSelectionPanel's
    // "removingAllOriginals" case), which is exactly the moment this needs to still save. Only
    // bail out when there's truly nothing to diff either way (fresh flow, nothing ever picked).
    if (!bulkMember || bulkSaving) return;
    if (bulkSlots.length === 0 && bulkOriginalBookings.length === 0) return;
    setBulkSaving(true);
    try {
      const clientId = bulkMember.id ?? bulkMember.client_id;
      const originalIds = new Set(bulkOriginalBookings.map((o) => o.id));
      const finalIds = new Set(bulkSlots.map((s) => s.id));
      // Still-selected originals are left alone entirely — only the actual diff against the
      // flow's starting snapshot turns into a real create/cancel call.
      const toCreate = bulkSlots.filter((s) => !originalIds.has(s.id));
      const toCancel = bulkOriginalBookings.filter((o) => !finalIds.has(o.id));

      if (toCreate.length === 0 && toCancel.length === 0) {
        closeBulkFlow();
        return;
      }

      if (toCreate.length > 0) {
        const timeSlots = toCreate.map((s) => ({
          client_id: clientId,
          status: "book",
          start: s.start,
          timeSlot_id: s.id,
        }));
        await ApiMethods.post("auth/add_booking_cancelation", { timeSlots });
      }
      if (toCancel.length > 0) {
        await Promise.all(
          toCancel.map((original) =>
            ApiMethods.post("auth/delete_bookings", {
              timeSlot_id: original.id,
              client_id: clientId,
              booking_id: original.booking_id,
              type: "canceled",
            })
          )
        );
      }

      refreshClientPackages(clientId);
      if (toCreate.length > 0 && toCancel.length > 0) {
        showAlert("Izmene termina su sačuvane", "success");
      } else if (toCancel.length > 0) {
        showAlert(
          toCancel.length === 1
            ? "Termin je otkazan"
            : `Otkazano ${toCancel.length} termina`,
          "success"
        );
      } else {
        showAlert(
          toCreate.length === 1
            ? "Uspešno zakazan 1 termin"
            : `Uspešno zakazana ${toCreate.length} termina`,
          "success"
        );
      }
      setBookingAdded((prev) => !prev);
      closeBulkFlow();
    } catch (err) {
      if (err?.code === "NO_AVAILABLE_PACKAGE") {
        showAlert(err.message, "error");
      } else {
        showAlert("Došlo je do greške pri zakazivanju termina", "error");
      }
    } finally {
      setBulkSaving(false);
    }
  };

  // Set when a member row is clicked in the Booked Members popup — holds the lightweight
  // booking-row client object (client_id/first_name/last_name/gender/photo_url), never a full
  // profile fetch. While set, the Calendar highlights every one of that member's appointments in
  // the currently selected week directly in the existing grid (see `renderTimeSlot` below),
  // instead of opening any separate list/popup. Booked Members itself is un-rendered while this
  // is active (`openUsersPopUp != null && !highlightedMember` gate below) rather than unmounted —
  // `openUsersPopUp` stays untouched, so Back just clears this and the same popup reappears
  // against the same slot/member list/week, no refetch.
  const [highlightedMember, setHighlightedMember] = useState(null);
  const handleSelectMemberWeek = (client) => {
    setHighlightedMember(client);
    if (isMobile && viewMode !== "week") {
      setViewMode("week");
    }
  };
  // Clicking any booked cell (highlighted or not) while highlight mode is active should behave
  // exactly like a normal click — open Booked Members for that slot — rather than doing nothing
  // because the popup stays gated off while `highlightedMember` is set. Only used for the cell
  // click path (renderTimeSlot → CardClientTest); PopupCard itself still gets the raw setter for
  // its own close/functional-update calls.
  const openBookedMembersPopup = (appt) => {
    setHighlightedMember(null);
    setUsersPopuop(appt);
  };
  const realAppointments =
    appointments &&
    Object.values(appointments)
      .filter((appointment) => appointment.checked)
      .filter((value, index, self) => {
        return index === self.findIndex((t) => t.id === value.id);
      });
  const addBooking = async () => {
    try {
      console.log("realAppointments", realAppointments);
      const clientId =
        activeClientInformation.id != null
          ? activeClientInformation.id
          : activeClientInformation.client_id;
      const timeSlots = Object.keys(realAppointments).map((appointment) => ({
        client_id: clientId,
        status: realAppointments[appointment].bookings_client.length
          ? "canceled"
          : "book",
        start: new Date(realAppointments[appointment].start),
        timeSlot_id: realAppointments[appointment].id,
      }));

      const data = {
        timeSlots: timeSlots,
      };

      const response = await ApiMethods.post(
        "auth/add_booking_cancelation",
        data
      );

      // All of `timeSlots` above belong to this one client (possibly several at once) — one
      // refresh covers them all, same reasoning as NewAppointmentFlow.jsx's handleSave.
      refreshClientPackages(clientId);
      setBookingAdded((prev) => !prev);
      setActiveClientInformation(null);
      setActiveReschedule(false);
      // handleClosePopup();
    } catch (err) {
      if (err?.code === "NO_AVAILABLE_PACKAGE") {
        showAlert(err.message, "error");
      } else {
        showAlert("Došlo je do greške pri izmeni termina", "error");
      }
    }
  };

  // const hours = Array.from(
  //   { length: endHour - startHour + 1 },
  //   (_, i) => i + startHour
  // );
  const hours = Array.from(
    { length: endHour - startHour + 1 },
    (_, i) => i + startHour
  ).filter((hour) => ![12, 13, 14].includes(hour));

  const handleToggleSidebar = (state, clientId, scheduler) => {
    console.log("usao ove");
    console.log(state, clientId, scheduler, "xdd");

    if (clientScheduler === 0 && clientId && scheduler) {
      setClientScheduler(clientId);
    } else if (state) {
      setIsSideBarOpen(clientId);
      setClientScheduler(0);
    } else {
      setIsSideBarOpen(null);
      setClientScheduler(0);
    }
  };
  const weekDays = ["Pon", "Uto", "Sre", "Čet", "Pet", "Sub"];

  useEffect(() => {
    handleFetchBookings();
    setMyAppointment([]);
  }, [
    selectedDate,
    activeReschedule,
    updateActiveReschedule,
    bookingAdded,
    activeClientInformation,
  ]);

  const activePackageClientId =
    activeClientInformation &&
    (activeClientInformation.id != null
      ? activeClientInformation.id
      : activeClientInformation.client_id);

  const fetchClientPackages = async () => {
    if (!activePackageClientId) {
      setClientPackages([]);
      return;
    }
    try {
      const response = await ApiMethods.get(
        `client-packages?client_id=${activePackageClientId}`
      );
      setClientPackages(response || []);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchClientPackages();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activePackageClientId]);

  const handlePackageSaved = () => {
    setPackageDialogOpen(false);
    setEditingClientPackage(null);
    fetchClientPackages();
    // Members screen / New Appointment picker cache this client's package
    // list too — mark it stale so the next time either is opened it
    // silently refreshes instead of showing the pre-change package.
    invalidateMembersCache();
  };

  const handleFetchBookings = async () => {
    const data = {
      client_id: localStorage.getItem("id"),
    };

    const startOfWeek = moment(selectedDate).clone().startOf("week");
    const startDate = startOfWeek.format("YYYY-MM-DD");

    const appointmentsResponse = await ApiMethods.get(
      `auth/bookings_per_client_timeslot?start=${startDate}`
    );

    const myAppointmentsResponse = await ApiMethods.post(
      "auth/client_bookings",
      data
    );
    console.log(myAppointmentsResponse, ":Appointentresponse");

    const tempAppointments = appointmentsResponse.map((appointment) => {
      const tempAppointment = {
        id: appointment.id,
        start: moment
          .parseZone(appointment.start)
          .format("YYYY-MM-DD HH:mm:ss"),
        end: moment.parseZone(appointment.end).format("YYYY-MM-DD HH:mm:ss"),
        max_bookings: appointment.max_bookings,
        used_bookings: appointment.used_bookings,
        free_bookings: appointment.free_bookings,
        bookings_client: appointment.bookings,
        status: null,
        checked: false,
      };

      const isMyAppointment =
        myAppointmentsResponse.findIndex((ma) => ma.id === appointment.id) > -1;

      if (activeReschedule && activeClientId) {
        tempAppointment.bookings_client = appointment.bookings.filter(
          (booking) => booking.client_id === activeClientId
        );
      }

      if (isMyAppointment) {
        tempAppointment.status = appointmentStatuses.BOOKED;
        tempAppointment.backgroundColor =
          appointmentStatusesProps.BOOKED.backgroundColor;
        tempAppointment.title = appointmentStatusesProps.BOOKED.title;
        return tempAppointment;
      }

      // Every slot's max_bookings is always 7 (the absolute ceiling) — a morning slot's lower
      // "normal" capacity (6) is derived from its hour here, not stored, so free_bookings alone
      // can't tell us it's full anymore. used_bookings >= normalCapacity is the real check.
      const { normalCapacity } = getSlotCapacityRules(
        moment(tempAppointment.start).hour()
      );
      if (tempAppointment.used_bookings >= normalCapacity) {
        tempAppointment.status = appointmentStatuses.FULL;
        tempAppointment.backgroundColor =
          appointmentStatusesProps.FULL.backgroundColor;
        tempAppointment.title = appointmentStatusesProps.FULL.title;
        return tempAppointment;
      }

      tempAppointment.status = appointmentStatuses.AVAILABLE;
      tempAppointment.backgroundColor =
        appointmentStatusesProps.AVAILABLE.backgroundColor;
      tempAppointment.title = appointmentStatusesProps.AVAILABLE.title;
      return tempAppointment;
    });

    const appointmentsObject = tempAppointments.reduce((acc, appointment) => {
      acc[appointment.start] = appointment;
      return acc;
    }, {});

    setAppointments(appointmentsObject);

    // Keep an already-open Booked Members popup in sync with whatever just
    // changed (a View Profile save, a removed/edited booking, ...) instead
    // of leaving it showing the pre-fetch snapshot. `forceCloseUsersPopUpRef`
    // is set only for a slot-changing edit save, where the old slot's popup
    // no longer makes sense to keep open regardless of who else is still
    // booked in it. Otherwise, close it only if the resynced slot has no
    // booked members left (e.g. the last one was just removed) — never
    // reload/reopen it, just point it at the fresh data for the same slot.
    if (forceCloseUsersPopUpRef.current) {
      forceCloseUsersPopUpRef.current = false;
      setUsersPopuop(null);
    } else {
      setUsersPopuop((prev) => {
        if (!prev) return prev;
        const fresh = appointmentsObject[prev.start];
        if (!fresh || (fresh.bookings_client || []).length === 0) return null;
        return fresh;
      });
    }
  };

  const checkCard = (key, id, appointment) => {
    console.log(appointment, "Ovo je app");
    let bookingExistInColumn = false;
    let bookingStateCheckedColumn = false;
    let canceledAppointment = [];

    const date = moment(key).format("YYYY-MM-DD");

    const isChecked = appointments[key].checked;

    if (
      appointment.bookings_client &&
      isChecked &&
      appointment.bookings_client.length > 0
    ) {
      Object.keys(appointments).forEach((key) => {
        if (key.startsWith(date) && appointments[key].id !== id) {
          appointments[key].checked = false;
        }
      });

      appointments[key].checked = !isChecked;

      setAppointments({ ...appointments });

      setMyAppointment((prevAppointments) => {
        if (isChecked) {
          return prevAppointments.filter((appt) => {
            const apptDate = moment(appt.start).format("YYYY-MM-DD");
            const appointmentDate = moment(appointment.start).format(
              "YYYY-MM-DD"
            );
            return appt.id !== appointment.id && apptDate !== appointmentDate;
          });
        } else {
          return [...prevAppointments, appointment];
        }
      });
      return;
    }

    Object.keys(appointments).forEach((key) => {
      if (key.startsWith(date) && appointments[key].id !== id) {
        if (
          appointments[key].bookings_client.length > 0 &&
          appointments[key].bookings_client[0].status !== "noshow"
        ) {
          console.log(appointments[key], "Appkey");
          bookingExistInColumn = true;
          bookingStateCheckedColumn = appointments[key].checked;
          console.log(bookingStateCheckedColumn);
          appointments[key].checked = true;
          canceledAppointment.push(appointments[key]);
        }
        if (appointments[key].bookings_client.length === 0) {
          // console.log("USO SAM3");
          //menjam ovo
          appointments[key].checked = false;
        }
      }
    });

    appointments[key].checked = !isChecked;

    setAppointments({ ...appointments });

    setMyAppointment((prevAppointments) => {
      if (isChecked) {
        return prevAppointments.filter((appt) => appt.id !== appointment.id);
      } else {
        return [
          ...prevAppointments.filter((appt) => appt.id !== appointment.id),
          ...canceledAppointment,
          appointment,
        ];
      }
    });

    console.log(appointments, "Appointment");
  };

  const renderTimeSlot = (date, hour, options = {}) => {
    const startDate = moment(date)
      .hour(hour)
      .minute(0)
      .second(0)
      .format("YYYY-MM-DD HH:mm:ss");
    const endDate = moment(date)
      .hour(hour + 1)
      .minute(0)
      .second(0)
      .format("YYYY-MM-DD HH:mm:ss");

    const appointment = appointments[startDate];
    // console.log("Appoint: ", appointment);

    const title = appointment ? appointment.title : "";
    const currentTime = moment();
    const isInRange = currentTime.isBetween(startDate, endDate, null, "[)");

    const isPastDayAndHour = moment(startDate)
      .startOf("hour")
      .isBefore(moment().startOf("hour"));
    const isFullSlot =
      !!appointment &&
      appointment.used_bookings >=
        getSlotCapacityRules(moment(startDate).hour()).normalCapacity;
    const slotStateClass = isPastDayAndHour
      ? "hf-slot-past"
      : isFullSlot
      ? "hf-slot-full"
      : isInRange
      ? "hf-slot-current"
      : "hf-slot-open";

    const isBulkMode = bulkStep === "select";
    const isBulkSelected =
      isBulkMode && appointment
        ? bulkSlots.some((s) => s.id === appointment.id)
        : false;
    // Was this slot part of the member's bookings when the flow started (not just "is it
    // currently selected")? Needed so the reservation-count preview only moves for a slot the
    // trainer actually just toggled, not one that was already theirs to begin with.
    const isBulkWasOriginal =
      isBulkMode &&
      !!appointment &&
      bulkOriginalBookings.some((o) => o.id === appointment.id);
    // Bulk mode allows selecting up to the same absolute ceiling (7) the Office App's
    // reschedule flow already overrides a morning slot's normal 6-person cap to — not
    // `isFullSlot`/`normalCapacity`, which would block that manual-add-the-7th behavior
    // entirely. Deliberately excludes `isPastDayAndHour` — CardClientTest.jsx's own `isLocked`
    // check handles the past case unconditionally (including for an already-selected slot,
    // which this flag alone must NOT block from being toggled back off).
    const isBulkDisabled =
      isBulkMode && !!appointment && !canOfficeAddMember(appointment.used_bookings);

    return (
      <div key={startDate} className={`time-slot ${slotStateClass}`}>
        <CardClientTest
          bulkMode={isBulkMode}
          bulkSelected={isBulkSelected}
          bulkWasOriginal={isBulkWasOriginal}
          bulkDisabled={isBulkDisabled}
          bulkMemberInitials={bulkMemberInitials}
          bulkMemberGender={bulkMember?.gender}
          onBulkToggle={toggleBulkSlot}
          activeClientInformation={activeClientInformation}
          setUsersPopuop={openBookedMembersPopup}
          setActiveClientInformation={setActiveClientInformation}
          activeReschedule={activeReschedule}
          setClientActive={setClientActiveId}
          activeClientId={activeClientId}
          isPastDayAndHour={isPastDayAndHour}
          checkCard={checkCard}
          appointment={appointment}
          isSideBarOpen={isSideBarOpen}
          handleToggleSidebar={handleToggleSidebar}
          clientScheduler={clientScheduler}
          onEmptySlotClick={options.onEmptySlotClick}
          weekCompact={options.weekCompact}
          highlightedClientId={highlightedMember?.client_id ?? null}
        />
      </div>
    );
  };

  const handleDeletePopup = () => {
    return (
      <DeletePopUp
        onConfirm={onConfirm}
        deleteAppointment={deleteAppointment}
        setClientActiveId={() => setClientActiveId(null)}
        setActiveClientInformation={setActiveClientInformation}
        activeClientInformation={activeClientInformation}
        closePopUp={() => setOpenDeletePopUp(false)}
      />
    );
  };

  return (
    <div
      className={`scheduler hf-cal ${
        activeClientInformation != null && activeClientInformation != undefined
          ? `scheduler-active`
          : ""
      } ${highlightedMember ? "hf-cal-highlight-active" : ""}`}
      // While highlight mode is active, every other child is `pointer-events: none` (see
      // `.hf-cal-highlight-active` in scheduler.css) so clicks on them never reach their own
      // handlers — they land here instead. Any click anywhere (not just the Back button) closes
      // the view exactly like Back, since a locked-but-unresponsive screen reads as broken to a
      // user who doesn't know only Back works.
      onClick={highlightedMember ? () => setHighlightedMember(null) : undefined}
    >
      {activeClientInformation && activeClientInformation != undefined && (
        <div className="info-client">
          <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <span
              style={{
                display: "flex",
                backgroundColor:
                  activeClientInformation && activeClientInformation.gender
                    ? activeClientInformation.gender === "Male"
                      ? "#97dfff"
                      : activeClientInformation.gender === "No"
                      ? "#adb5bd"
                      : "#FF8E8B"
                    : "transparent",
                stroke: "black",
                border: "1px solid black",
                strokeWidth: "0.5px",
              }}
              className="circle-card"
            ></span>

            <div style={{ display: "flex", alignItems: "center" }}>
              <div className="info-client-name" style={{ marginRight: "10px" }}>
                {activeClientInformation.first_name}{" "}
                {activeClientInformation.last_name}
              </div>
              <div onClick={() => setOpenDeletePopUp(true)}>
                <DeleteOutlineOutlinedIcon
                  style={{
                    objectFit: "contain",
                    width: "21px",
                    height: "21px",
                    color: "#E55050",
                  }}
                />
              </div>
              <IconButton
                size="small"
                onClick={() => {
                  setEditingClientPackage(null);
                  setPackageDialogOpen(true);
                }}
              >
                <CardGiftcardOutlinedIcon
                  sx={{ color: "#357a38", fontSize: "20px" }}
                />
              </IconButton>
            </div>
          </div>

          <div
            style={{
              maxWidth: "180px",
              display: "flex",
              alignItems: "center",
              justifyContent: "end",
              width: "100%",
              gap: "10px",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                overflow: "hidden",
              }}
            >
              {activeClientInformation.phone && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginRight: "5px",
                    flexShrink: 1,
                    overflow: "hidden",
                    minWidth: 0,
                    gap: "3px",
                  }}
                >
                  <PhoneIcon />
                  <span
                    style={{
                      fontSize: "10px",
                      lineHeight: "30px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      maxWidth: "120px",
                      display: "inline-block",
                    }}
                  >
                    {activeClientInformation.phone}
                  </span>
                </div>
              )}
            </div>

            <IconButton onClick={() => setOpenPopup((prev) => !prev)}>
              <EditRoundedIcon sx={{ color: "#2196F3" }} />
            </IconButton>
            <IconButton>
              <WorkHistoryIcon
                style={{ color: "#353839" }}
                onClick={() => setOpenAgenda((prev) => !prev)}
              />
            </IconButton>
          </div>
        </div>
      )}

      {activeClientInformation && activeClientInformation != undefined && (
        <ClientPackagesList
          packages={clientPackages}
          onEdit={(pkg) => {
            setEditingClientPackage(pkg);
            setPackageDialogOpen(true);
          }}
        />
      )}

      {packageDialogOpen && (
        <ClientPackageDialog
          open={packageDialogOpen}
          onClose={() => {
            setPackageDialogOpen(false);
            setEditingClientPackage(null);
          }}
          clientId={activePackageClientId}
          editingPackage={editingClientPackage}
          onSaved={handlePackageSaved}
        />
      )}

      {highlightedMember && (
        <div className="hf-cal-highlight-bar">
          <IconButton
            className="hf-cal-highlight-back"
            aria-label="Nazad"
            onClick={() => setHighlightedMember(null)}
          >
            <ArrowBackIosNewIcon sx={{ fontSize: 14 }} />
          </IconButton>
          <Avatar
            className="hf-cal-highlight-avatar"
            src={highlightedMember.photo_url || undefined}
            sx={{
              backgroundColor:
                highlightedMember.gender === "Male" ? "#97dfff" : "#FF8E8B",
              color: "black",
              fontWeight: "700",
            }}
          >
            {highlightedMember.first_name
              ? highlightedMember.first_name.charAt(0).toUpperCase()
              : "?"}
            {highlightedMember.last_name
              ? highlightedMember.last_name.charAt(0).toUpperCase()
              : "?"}
          </Avatar>
          <span className="hf-cal-highlight-text">
            <span className="hf-cal-highlight-text-label">
              Prikaz termina za:
            </span>{" "}
            {highlightedMember.first_name} {highlightedMember.last_name}
          </span>
        </div>
      )}

      <div
        className={`hf-cal-layout${
          bulkStep === "select" && !isMobile ? " hf-cal-layout-split" : ""
        }`}
      >
      <div className="hf-cal-main">
      {isMobile ? (
        <>
          {/* This date-nav row now lives in the fixed Mobile header instead (MobileHeader's
              `title` slot, wired up in CalendarTest/index.js with this exact same
              handleNavigate/handleMobileToday) — kept here as a comment rather than deleted in
              case the header placement doesn't work out and this needs to come back.
          <CalendarWeekNav
            variant="mobile"
            label={weekRangeLabel}
            onPrev={() => handleNavigate("prev")}
            onNext={() => handleNavigate("next")}
            onToday={handleMobileToday}
          />
          */}

          {/* Dan/Nedelja switch — commented out to try Mobile with Week View only (takes up
              real estate, and Day View may not end up being used at all). Restore by
              uncommenting this block and the Day View branch just below it.
          <div className="hf-cal-m-viewtoggle">
            <button
              type="button"
              className={`hf-cal-m-viewtoggle-btn${
                viewMode === "day" ? " active" : ""
              }`}
              onClick={() => setViewMode("day")}
            >
              Dan
            </button>
            <button
              type="button"
              className={`hf-cal-m-viewtoggle-btn${
                viewMode === "week" ? " active" : ""
              }`}
              onClick={() => setViewMode("week")}
            >
              Nedelja
            </button>
          </div>
          */}

          {/* Day View — commented out along with the switch above; Week View always renders
              below now regardless of `viewMode`. Restore by uncommenting this whole block back
              to a real ternary (`viewMode === "day" ? ( ... day view ... ) : ( ... week view
              ... )`) and un-commenting the switch buttons above.
          viewMode === "day" ? (
            <>
              <div className="hf-cal-m-daystrip">
                {currentWeekDates.map((date, index) => {
                  const isToday = moment(date).isSame(moment(), "day");
                  const isActive = index === mobileActiveDayIndex;
                  return (
                    <button
                      key={index}
                      type="button"
                      className={`hf-cal-m-daychip${isActive ? " active" : ""}`}
                      onClick={() => setMobileActiveDayIndex(index)}
                    >
                      <span className="hf-cal-m-daychip-label">
                        {weekDays[index].toUpperCase()}
                      </span>
                      <span className="hf-cal-m-daychip-num">
                        {date.getDate()}
                      </span>
                      {isToday && <span className="hf-cal-m-daychip-dot" />}
                    </button>
                  );
                })}
              </div>

              <div className="hf-cal-m-agenda">
                {hours.map((hour) => {
                  const currentHour = new Date().getHours();
                  const activeDayDate = currentWeekDates[mobileActiveDayIndex];
                  const isCurrentHour =
                    hour === currentHour &&
                    moment(activeDayDate).isSame(moment(), "day");
                  const isPastRow = moment(activeDayDate)
                    .hour(hour)
                    .startOf("hour")
                    .isBefore(moment().startOf("hour"));

                  return (
                    <React.Fragment key={hour}>
                      <div
                        className={`hf-cal-m-row ${
                          isCurrentHour ? "current-hour" : ""
                        } ${isPastRow ? "hf-cal-m-row-past" : ""}`}
                      >
                        <div className="hf-cal-m-hour">{`${hour}:00`}</div>
                        <div className="hf-cal-m-slot">
                          {renderTimeSlot(activeDayDate, hour)}
                        </div>
                      </div>
                      {hour === 11 && (
                        <div className="hf-cal-break-row" aria-hidden="true">
                          <span className="hf-cal-break-label">
                            12:00 – 15:00
                          </span>
                          <span className="hf-cal-break-bar" />
                        </div>
                      )}
                    </React.Fragment>
                  );
                })}
              </div>
            </>
          ) : ( */}
            <MobileWeekGrid
              weekDates={currentWeekDates}
              dayLabels={weekDays}
              hours={hours}
              breakAfterHour={11}
              gridClassName={bulkStep === "select" ? "hf-cal-m-week-grid-bulk" : ""}
              onDayHeaderClick={(index) => {
                setMobileActiveDayIndex(index);
                setViewMode("day");
              }}
              renderCell={(date, hour) =>
                renderTimeSlot(date, hour, {
                  onEmptySlotClick: () => handleWeekEmptySlotTap(date, hour),
                  weekCompact: true,
                })
              }
            />

          {!activeClientInformation && !bulkStep && (
            <button
              type="button"
              className="hf-cal-m-fab"
              onClick={startBulkFlow}
              aria-label="Novi termin"
            >
              <CalendarMonthIcon />
              <AddIcon className="hf-cal-m-fab-plus" />
            </button>
          )}
        </>
      ) : (
        <>
          <div className="hf-cal-toolbar">
            <div className="hf-cal-topbar-title">
              <h2 className="hf-cal-title">Kalendar</h2>
              <p className="hf-cal-title-hint">{weekRangeLabel}</p>
            </div>
            <div className="hf-cal-topbar-actions">
              <CalendarWeekNav
                variant="desktop"
                onPrev={() => handleNavigate("prev")}
                onNext={() => handleNavigate("next")}
                onToday={() => handleNavigate("today")}
              />
              <button
                type="button"
                className="hf-cal-new-appt-btn"
                onClick={startBulkFlow}
              >
                <AddIcon fontSize="small" />
                Novi termin
              </button>
              <button
                type="button"
                className="hf-cal-bell-btn"
                aria-label="Obaveštenja"
                onClick={openNotif}
              >
                <NotificationsOutlinedIcon fontSize="small" />
                {unreadCount > 0 && (
                  <span className="hf-cal-bell-badge">
                    {unreadCount > 9 ? "9+" : unreadCount}
                  </span>
                )}
              </button>
            </div>
          </div>
          <div className="cal-header-row">
            <div className="hf-cal-corner" />
            {currentWeekDates.map((date, index) => {
              const isCurrentDate = moment(date).isSame(moment(), "day");
              const hasDatePassed = moment(date).isBefore(moment(), "day");

              return (
                <div
                  key={index}
                  className={`day-header${isCurrentDate ? " hf-day-today" : ""}${hasDatePassed ? " hf-day-past" : ""}`}
                >
                  {index === 0 && (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 9 10"
                      fill="none"
                      className="arrow-header"
                      style={{
                        position: "absolute",

                        cursor: "pointer",
                      }}
                      onClick={() => handleNavigate("prev")}
                    >
                      <path
                        d="M-2.40413e-07 5L8.25 9.76314L8.25 0.236861L-2.40413e-07 5Z"
                        fill="#A9A9A9"
                      />
                    </svg>
                  )}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <span
                      className="day-text"
                      style={{ textTransform: "uppercase" }}
                    >
                      {weekDays[index]}
                    </span>
                    <span className="day-number">
                      {/* {date.toLocaleString("default", { month: "short" })}{" "} */}
                      {date.getDate()}
                    </span>
                    {isCurrentDate && (
                      <span
                        className="hf-cal-today-dot"
                        aria-hidden="true"
                      />
                    )}
                  </div>
                  {index === currentWeekDates.length - 1 && (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="9"
                      height="10"
                      viewBox="0 0 9 10"
                      fill="none"
                      className="arrow-header-right"
                      style={{
                        position: "absolute",

                        cursor: "pointer",
                      }}
                      onClick={() => handleNavigate("next")}
                    >
                      <path
                        d="M9 5L0.75 0.23686L0.75 9.76314L9 5Z"
                        fill="#A9A9A9"
                      />
                    </svg>
                  )}
                </div>
              );
            })}
          </div>
          <div className="cal-row">
            {hours.map((hour) => {
              const currentHour = new Date().getHours();
              const isCurrentHour = hour === currentHour;

              return (
                <React.Fragment key={hour}>
                  <div
                    className={`hour-row ${
                      isCurrentHour ? "current-hour" : ""
                    }`}
                  >
                    <div className="hour time-slot">{`${hour}:00`}</div>
                    {currentWeekDates.map((date, dayIndex) => {
                      const isCurrentDate = moment(date).isSame(
                        moment(),
                        "day"
                      );
                      const hasDatePassed = moment(date).isBefore(
                        moment(),
                        "day"
                      );
                      return (
                        <div
                          style={{ padding: "3px" }}
                          key={dayIndex}
                          className={`hf-cal-day-col${
                            isCurrentDate ? " hf-day-today" : ""
                          }${hasDatePassed ? " hf-day-past" : ""}`}
                        >
                          {renderTimeSlot(date, hour)}
                        </div>
                      );
                    })}
                  </div>
                  {hour === 11 && (
                    <div className="hf-cal-break-row" aria-hidden="true">
                      <span className="hf-cal-break-label">
                        12:00 – 15:00
                      </span>
                      <span className="hf-cal-break-bar" />
                    </div>
                  )}
                </React.Fragment>
              );
            })}
          </div>
        </>
      )}
      </div>

      {bulkStep === "select" && !isMobile && (
        <BulkSelectionPanel
          member={bulkMember}
          slots={bulkSlots}
          maxSlots={MAX_BULK_SLOTS}
          saving={bulkSaving}
          onRemove={removeBulkSlot}
          onSave={handleBulkSave}
          onCancel={closeBulkFlow}
          isMobile={isMobile}
          originalCount={bulkOriginalBookings.length}
        />
      )}
      </div>
      <SideBarTest
        setOpenAgenda={() => setOpenAgenda((prev) => !prev)}
        setDeletePopUp={() => setOpenDeletePopUp(true)}
        setActiveClientInformation={setActiveClientInformation}
        checkCard={checkCard}
        client_id={activeClientId}
        toggleSidebar={() => setClientActiveId(null)}
        closeSidebar={() => setActiveReschedule(false)}
        setActiveReschedule={() => setActiveReschedule((prev) => !prev)}
        appointments={isMyAppointment}
        activeReschedule={activeReschedule}
        refresh={() => setUpdateActiveReschedule((prev) => !prev)}
        openPopup={() => setOpenPopup((prev) => !prev)}
        appointmentsAll={appointments}
        activeClientInformation={activeClientInformation}
      />
      {openUsersPopUp != null && !highlightedMember && (
        <PopupCard
          setBookingAdded={() => setBookingAdded((prev) => !prev)}
          setOnConfirm={setOnConfirm}
          setOpenDeletePopUp={() => setOpenDeletePopUp(true)}
          setActiveClientInfo={setActiveClientInfo}
          setUsersPopuop={setUsersPopuop}
          appointment={openUsersPopUp}
          setActiveAppointment={setActiveAppointment}
          onEditAppointment={(client, appointment) =>
            setEditingAppointmentContext({ client, appointment })
          }
          onSelectMemberWeek={handleSelectMemberWeek}
        />
      )}

      {(openNewAppointment || editingAppointmentContext) && (
        <NewAppointmentFlow
          onClose={() => {
            setOpenNewAppointment(false);
            setEditingAppointmentContext(null);
            setWeekTapSlot(null);
          }}
          initialDate={weekTapSlot ? weekTapSlot.date : selectedDate}
          initialHour={weekTapSlot ? weekTapSlot.hour : undefined}
          refresh={(opts) => {
            if (editingAppointmentContext && opts?.slotChanged) {
              forceCloseUsersPopUpRef.current = true;
            }
            setBookingAdded((prev) => !prev);
          }}
          editingClient={editingAppointmentContext?.client}
          editingAppointment={editingAppointmentContext?.appointment}
        />
      )}

      {bulkStep === "member" && (
        <NewAppointmentFlow
          bulkMode
          onMemberChosen={handleBulkMemberChosen}
          onClose={closeBulkFlow}
        />
      )}

      {bulkStep === "select" && isMobile && (
        <BulkSelectionPanel
          member={bulkMember}
          slots={bulkSlots}
          maxSlots={MAX_BULK_SLOTS}
          saving={bulkSaving}
          onRemove={removeBulkSlot}
          onSave={handleBulkSave}
          onCancel={closeBulkFlow}
          isMobile={isMobile}
          originalCount={bulkOriginalBookings.length}
        />
      )}

      <CircularButton
        syncContacts={syncContacts}
        activeClientInformation={activeClientInformation}
        setActiveClientInformation={setActiveClientInformation}
        activeClientId={activeClientId}
        setClientActive={setClientActiveId}
        handleToggleSidebar={handleToggleSidebar}
        openPopup={() => setOpenPopup((prev) => !prev)}
        openPopupState={openPopup}
        openSidebarClient={openSidebarClient}
        setOpenSidebarClient={() => setOpenSidebarClient((prev) => !prev)}
      />
      {openPopup && (
        <PopupTest
          setActiveClientInformation={setActiveClientInformation}
          activeClientInformation={activeClientInformation}
          refresh={() => setUpdateActiveReschedule((prev) => !prev)}
          openPopup={() => setOpenPopup((prev) => !prev)}
        />
      )}
      {activeClientInformation &&
        activeClientInformation != 0 &&
        (!activeReschedule ? (
          <div className="scheduler-mobile">
            <button
              className="scheduler-sidebar-mobile"
              onClick={() => setActiveReschedule((prev) => !prev)}
            >
              Zakazati / Promeniti
            </button>
          </div>
        ) : (
          <div
            className="bottom-sidebar-mobile"
            style={{
              justifyContent: "space-around",
              alignItems: "center",
            }}
          >
            <button
              className="close-change-booking-mobile"
              onClick={() => {
                setActiveClientInformation(null);
                setActiveReschedule(false);
              }}
            >
              Otkaži
            </button>
            <button
              className="reschedule-change-booking-mobile"
              onClick={() => addBooking()}
            >
              Sačuvaj
            </button>
          </div>
        ))}

      {openAgenda && (
        <Agenda
          activeClientId={activeClientId}
          setOpenAgenda={() => setOpenAgenda((prev) => !prev)}
        />
      )}
      {openDeletePopUp && handleDeletePopup()}
      {Object.keys(activeAppointment).length > 0 && (
        <CardClient
          booking_client={activeClientInfo}
          setActiveAppointment={setActiveAppointment}
          setClientActive={setClientActiveId}
          setOpenSidebarClient={setOpenSidebarClient}
          activeAppointment={activeAppointment}
          setActiveClientInformation={setActiveClientInformation}
          setActiveReschedule={() => setActiveReschedule((prev) => !prev)}
          setUpdateActiveReschedule={() =>
            setUpdateActiveReschedule((prev) => !prev)
          }
        />
      )}
    </div>
  );
};

export default SchedulerTest;
